import request from '@/utils/requestTask'
import store from '@/store/index';

export function getQrFlag(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "get_qr_flag"
        }, data)
    })
}

export function getQrcodeInfo(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "get_qrcode_info"
        }, data)
    })
}

export function getQrcode(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "get_qrcode"
        }, data)
    })
}

export function setAppPassword(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "set_app_password"
        }, data)
    })
}

export function loginRequest(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "login"
        }, data)
    })
}

export function getVersion(data) {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: Object.assign({
            action: "get_version"
        }, data)
    })
}

//获取最新的域名池
export function getNewestDomainPool() {
    return request({
        url: '/Verify/index',
        method: 'get',
        params: {
            action: "get_domain_pool"
        }
    })
}

export function ping(domain) {
    return request({
        url: `https://task.${domain}/Verify/ping`,
        method: 'get',
    })
}

//获取活动公告信息
export function getNotice(data) {
    return request({
        url: '/Notice/getNotice',
        method: 'get',
        params: data
    })
}

//获取热门活动推送
export function getHotGamePush(data) {
    return request({
        url: '/RecommendGame/getRecommend',
        method: 'get',
        params: data
    })
}

//获取当前皮肤
export function getAppTheme() {
    return request({
        url: '/Activity/getActivityType',
        method: 'get'
    })
}
//获取时时彩信息
export function getLotteryInfo(data) {
    return request({
        url: '/TimeAward/getLotteryInfo',
        method: 'get',
        params: data
    })
}

//获取帮助信息
export function getHelpInfo(gameId, lang) {
    return request({
        url: '/GameHelp/getInfo',
        method: 'get',
        params: {
            game_id: gameId,
            lang: lang,
            channel_id: store.state.app.appInfo.channel_id,
            identity: store.state.app.appInfo.identity
        }
    })
}

/**获取幸运轮盘是否开启 */
export function checkLuckDrawStatus() {
    return request({
        url: '/Api/checkLuckDrawStatus',
        method: 'post',
        params: {
            game_id: store.state.app.currentGameID,
            channel_id: store.state.app.appInfo.channel_id,
            identity: store.state.app.appInfo.identity
        }
    })
}